import React from 'react';
import PropTypes from 'prop-types';

import SrText from 'client/components/SrText';
import SrFlexRow from 'client/components/SrFlexRow/SrFlexRow';
import SrBox from 'client/components/SrBox';
import SrTextList from 'client/components/SrTextList';
import SrTag, {
  SR_TAG_THEME_GREY_OUTLINE,
  SR_TAG_THEME_ORANGE_OUTLINE,
} from 'client/components/SrTag/SrTag';

const SrLeadOutcomesReasonItem = ({ label, count, details, isHiglighted }) => {
  return (
    <SrBox marginTop="12px">
      <SrTag
        theme={isHiglighted ? SR_TAG_THEME_ORANGE_OUTLINE : SR_TAG_THEME_GREY_OUTLINE}
        variation="leadOutcomes"
      >
        <SrFlexRow>
          <SrText font="greycliff" weight="800" fontSize="16px" lineHeight="24px">
            {label} ({count})
          </SrText>
        </SrFlexRow>
        <SrBox marginLeft="8px">
          <SrTextList textList={details} />
        </SrBox>
      </SrTag>
    </SrBox>
  );
};

SrLeadOutcomesReasonItem.propTypes = {
  label: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  details: PropTypes.array,
  isHiglighted: PropTypes.bool.isRequired,
};

export default SrLeadOutcomesReasonItem;
